/**
 * Query keys factory for Story Setup PDF
 * Provides consistent query key generation for caching and invalidation
 */
export const storySetupPdfQueryKeys = {
  all: ['storySetupPdf'] as const,

  story: (storyId: string) => [...storySetupPdfQueryKeys.all, 'story', storyId] as const,

  storyContents: (storyId: string) => [...storySetupPdfQueryKeys.all, 'storyContents', storyId] as const,

  storyHtmlContent: (storyId: string) => [...storySetupPdfQueryKeys.all, 'storyHtmlContent', storyId] as const,

  previewPdf: (storyId: string) => [...storySetupPdfQueryKeys.all, 'previewPdf', storyId] as const,

  exportPdf: (storyId: string) => [...storySetupPdfQueryKeys.all, 'exportPdf', storyId] as const,

  settings: (entityId: number) => [...storySetupPdfQueryKeys.all, 'settings', entityId] as const
} as const;

export type StorySetupPdfQueryKeys = typeof storySetupPdfQueryKeys;
